<div class="d-flex flex-column min-vh-100">
  <app-header></app-header>
  <main [@siRouterFadeAnimation]="getRouteAnimation(route)" class="flex-fill">
    <div [style]="greyOut">
      <router-outlet #route="outlet"></router-outlet>
    </div>
    <!-- Toast Template for SUCCESS, INFO, WARNING types -->
    <ng-template #toastTemplate let-msgKey="msgKey" let-textFetch="textFetch">
      {{ textFetch(msgKey) }}
    </ng-template>
    <!-- ERROR toasts now use ErrorToastComponent instead of template -->
  </main>
  <app-footer></app-footer>
</div>
